import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/lib/jenkins/workspace/oh0t/landry/portal/src_bfd5ad77/layouts/default.vue"))
}